import { ReactNode } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import styles from './styles.module.scss';
import CheckCircleIcon from '../../assets/icons/check-circle-outline.svg';
import CloseCircleIcon from '../../assets/icons/close-circle-outline.svg';
import { Link } from 'components/common/link';
import { redirecTo } from 'utils';
import { useTranslation } from 'react-i18next';

interface CardResultProps {
  children: ReactNode;
  error: boolean;
  backUrl?: string;
}

const CardResult = ({ children, error, backUrl }: CardResultProps) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobileL = useMediaQuery('(min-width:700px)');
  const isMobileM = useMediaQuery('(min-width:600px)');
  const isMobileS = useMediaQuery('(min-width:500px)');
  const isMobileXS = useMediaQuery('(min-width:400px)');

  const topEffect = () => {
    const result = [];
    let circles = isMobileL ? 28 : isMobileM ? 26 : isMobileS ? 22 : isMobileXS ? 18 : 14;
    while (circles !== 0) {
      result.push(
        <div
          key={`card-result-circle-${circles}`}
          className={styles.card_result_box_top_circle}
          style={{ background: error ? theme.palette.error.main : theme.palette.success.main }}
        />
      );
      circles -= 1;
    }
    return <div className={styles.card_result_box_top}>{result.map(circle => circle)}</div>;
  };

  return (
    <div>
      <div
        className={styles.card_result}
        style={{ background: error ? theme.palette.error.main : theme.palette.success.main }}
      >
        <div className={styles.card_result_icon}>
          <img className={styles.card_result_icon_img} src={error ? CloseCircleIcon : CheckCircleIcon} alt="icon-error" />
        </div>
        <div className={styles.card_result_box}>
          {topEffect()}
          <div>{children}</div>
          {backUrl && (
            <div className={styles.card_result_return}>
              <Link onClick={() => backUrl && redirecTo(backUrl)}>{t('common.return')}</Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CardResult;
